export { default as Img200 } from './processed/200/THE-LAKEHOUSE.jpg';
export { default as Img400 } from './processed/400/THE-LAKEHOUSE.jpg';
export { default as Imgthumb } from './processed/thumb/THE-LAKEHOUSE.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/THE-LAKEHOUSE.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/THE-LAKEHOUSE.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      185,
      129,
      53
    ],
    "_population": 2507,
    "_hsl": [
      0.09595959595959595,
      0.5546218487394957,
      0.4666666666666667
    ]
  },
  "LightVibrant": {
    "_rgb": [
      252,
      223,
      172
    ],
    "_population": 519,
    "_hsl": [
      0.10624999999999997,
      0.9302325581395351,
      0.8313725490196079
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      118,
      75,
      31
    ],
    "_population": 791,
    "_hsl": [
      0.08429118773946359,
      0.5838926174496644,
      0.29215686274509806
    ]
  },
  "Muted": {
    "_rgb": [
      88,
      163,
      149
    ],
    "_population": 417,
    "_hsl": [
      0.4688888888888889,
      0.298804780876494,
      0.492156862745098
    ]
  },
  "LightMuted": {
    "_rgb": [
      192,
      198,
      170
    ],
    "_population": 940,
    "_hsl": [
      0.2023809523809524,
      0.19718309859154934,
      0.7215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      50,
      76,
      68
    ],
    "_population": 12,
    "_hsl": [
      0.44871794871794873,
      0.20634920634920634,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/THE-LAKEHOUSE.js